import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'assets/css/custom.css'
import Store from './store'
import Routes from './Router'
import ModalForm from 'components/ModalForm'
import PreviewModal from 'components/PreviewModal'
import { I18nextProvider } from 'react-i18next'
import i18next from 'Language'
import { SWRConfig } from 'swr'
import { apiRequest } from 'store/Misc/apiRequest'
import { destructureErrorMessage } from 'Helper'
import { ErrorBoundary } from 'react-error-boundary'
import { LayoutContextProvider } from './contexts/LayoutContext'
import { MovieProvider } from 'contexts/MovieContext'
import { AddMovieProvider } from 'contexts/AdsMovieContext'
import Btn from 'components/Btn'


function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div role="alert" className="flex flex-col items-center justify-center h-[100vh] text-center">
      <div>
        <h1>Something went wrong</h1>
        <pre>{error?.message}</pre>
        {/* <button onClick={resetErrorBoundary}>Try again</button> */}
        <Btn content={'Try again'} click={resetErrorBoundary} />
      </div>
    </div>
  )
}



  export const fetcher = async (url, method) => {
    try {
      const data = await apiRequest({
        method,
        url
      })

      return data
    } catch ({ message }) {
      destructureErrorMessage(message).map(msg => {
        return (window.location.pathname === 'login' && msg === "Unauthenticated") ? toast.error(msg, { autoClose: 15000 }) : null
      })
    }
  }

function App() {

  return (
    <SWRConfig
    
      value={{
        fetcher,
        revalidateOnFocus:false,
        
      }}
    >
      <Provider store={Store}>
        <div className="App">
          <ModalForm />
          <PreviewModal />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <LayoutContextProvider>
            <MovieProvider>
              <AddMovieProvider>
            <I18nextProvider i18n={i18next}>
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {
                  // reset the state of your app so the error doesn't happen again
                }}
              >
                <Router>
                  <Routes />
                </Router>
              </ErrorBoundary>
            </I18nextProvider>
            </AddMovieProvider>
            </MovieProvider>
          </LayoutContextProvider>
        </div>
      </Provider>
    </SWRConfig>
  )
}

export default App
